import { render, staticRenderFns } from "./CuentaNav.vue?vue&type=template&id=2bcacec5"
import script from "./CuentaNav.vue?vue&type=script&lang=js"
export * from "./CuentaNav.vue?vue&type=script&lang=js"
import style0 from "./CuentaNav.vue?vue&type=style&index=0&id=2bcacec5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports